// @ts-nocheck
import yoda from '@kibt/bridge';
import { versionCompare } from '@kibt/web-utils/version';
import { appVersion } from '../device-info';

const containerIdentity = '' + Date.now().valueOf() + Math.random() * 1024;

const setCloseContainerOnClickOutsideAvailable = versionCompare(appVersion, '9.9.40') !== -1;

export const setContainerOnClickOutside = (ifClickable: boolean, identity = containerIdentity) => {
    if (!setCloseContainerOnClickOutsideAvailable) return;
    (yoda.invoke ?? yoda.kwaiInvoke)?.('component.setCloseContainerOnClickOutside', {
        closeContainer: ifClickable, // false: 点击容器外部，不关闭容器；true: 点击容器外部，关闭容器；
        identity,
    }).catch((e) => e);
};

// 忽略容器外部的点击
export const ignoreOutsideClick = (identity = containerIdentity) => {
    if (!setCloseContainerOnClickOutsideAvailable) return;
    (yoda.invoke ?? yoda.kwaiInvoke)?.('component.setCloseContainerOnClickOutside', {
        closeContainer: false,
        identity: identity,
    }).catch((e) => e);
};

// 允许容器外部的点击关闭容器
export const allowDefaultOutsideClick = (identity = containerIdentity) => {
    if (!setCloseContainerOnClickOutsideAvailable) return;
    (yoda.invoke ?? yoda.kwaiInvoke)?.('component.setCloseContainerOnClickOutside', {
        closeContainer: true, // false: 点击容器外部，不关闭容器；true: 点击容器外部，关闭容器；
        identity,
    }).catch((e) => e);
};

export const onClickContainerOutside = (cb: Function, identity = containerIdentity) => {
    if (!setCloseContainerOnClickOutsideAvailable) return;
    try {
        const func = (res) => {
            const result = typeof res === 'string' ? JSON.parse(res) : res;
            if (result.identity !== identity) return;
            console.log('点击容器外部');
            // 调用回调后需要「允许容器外部的点击关闭容器」，并移除相关回调
            cb();
            allowDefaultOutsideClick();
            yoda.event.removeEventListener('onClickContainerOutside', func);
        };
        yoda.event.addEventListener('onClickContainerOutside', func);
    } catch (error) {}
};
